import { Helmet } from 'react-helmet';

type HeadProps = {
    title: string;
    description: string;
    image?: string;
    url?: string;
    siteName?: string;
    metaNameTitle?: string;
}

function Head({ title, description, image, url = '', siteName = "Netpeak One — HRM system for Netpeak Group" , metaNameTitle = ''}: HeadProps) {
    const baseURL = `${window.location.protocol}//${window.location.host}`;

    const defaultImage = `${baseURL}/icon.svg`;

    return (
        <Helmet>
            <meta property="og:site_name" content={siteName}></meta>
            <title>{title}</title>
            <meta name="title" content={metaNameTitle}></meta>
            <meta name="description" content={description}></meta>
            <meta property="og:title" content={title}></meta>
            <meta property="og:image" content={image || defaultImage}></meta>
            <meta property="og:url" content={baseURL + url}></meta>
            <meta property="og:description" content={description}></meta>
        </Helmet>
    );
}

export default Head;
